import React from 'react';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';
import Header from '../components/Header';

const AboutUs = () => {
  return (
    <>
    <section 
      className="relative w-full min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] bg-cover bg-center"
      style={{
        backgroundImage: "url('blog13.png')",
      }}
    >
      <Header/>

      {/* Hero Content */}
      <div className="relative z-20 flex items-center justify-center min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] px-4">
        <div className="max-w-5xl text-center text-white">
          <h1 className="font-bold leading-snug text-white">
            About Us
          </h1>
          <div className="mt-6 flex justify-center gap-2 text-sm font-medium">
            <a href="/" className="hover:text-logo-green">Home</a>
            <span>-</span>
            <span className="text-logo-green">About Us</span>
          </div>
        </div>
      </div>
    </section>

        {/* Premier Service Section - Image Left, Text Right */}
      <section className="bg-white py-8 px-5 md:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            {/* Image Side */}
            <div>
              <img 
                src="blog11.png" 
                alt="Luxury Fleet" 
                className="w-full h-96 object-cover rounded-lg shadow-lg"
              />
            </div>

            {/* Text Side */}
            <div>
              <h2 className="font-bold text-black mb-3 leading-tight">
                ABOUT US
              </h2>
              <p className="mb-2 text-gray-900">
               Experience the ultimate in luxury and comfort with Majestic Voyague NYC your trusted partner for premium limousine services in New York City. Whether it's airport transfers, corporate events, weddings, or a night out in town, we provide professional chauffeurs and high-end vehicles to make every journey special.
              </p>
              <p className="mb-3 text-gray-900">
              Our commitment to punctuality, cleanliness, and customer satisfaction makes us the preferred choice for thousands of clients across NYC. We believe in providing not just a ride – but an experience that reflects class, safety, and reliability.
              </p>
              <div className="flex gap-4">
                <a 
                  href="/booknow" 
                  className="bg-black border-2 border-white text-white px-8 py-3 font-semibold hover:bg-gray-900 transition-colors"
                >
                  Book Now
                </a>
                <a 
                  href="tel:+17182004140" 
                  className="bg-white text-black border-2 border-black px-8 py-3 font-semibold hover:bg-gray-100  transition-colors"
                >
                  CALL NOW
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

    <section className="w-full py-6 px-4 md:px-8 bg-white">
      <div className="max-w-4xl mx-auto">
        {/* WHO WE ARE heading */}
        <h2 className="font-bold text-black mb-8 text-center">
          WHO WE ARE
        </h2>
        
        {/* Description paragraph */}
        <p className="text-gray-900 leading-relaxed mb-12 text-center">
          We are a team of highly trained chauffeurs, coordinators, and support staff committed to delivering 5-star ground transportation throughout NYC and surrounding areas. With years of experience in airport transportation, corporate travel, and luxury event services, ATL Airports Limo has become a trusted name for business travelers, tourists, locals, and special event organizers.
        </p>

        {/* Buttons container */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          {/* BOOK NOW link */}
          <a 
            href="/booknow" 
            className="bg-black text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-800 transition-colors w-full sm:w-auto min-w-[200px] text-center"
          >
            BOOK NOW
          </a>
          
          {/* CALL NOW link */}
          <a 
            href="tel:+17182004140" 
            className="bg-transparent border-2 border-black text-black px-8 py-4 rounded-lg font-semibold text-lg hover:bg-black hover:text-white transition-colors w-full sm:w-auto min-w-[200px] text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </section>

            {/* Premier Service Section - Image Left, Text Right */}
      <section className="bg-white py-8 px-5 md:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            {/* Image Side */}
            <div>
              <img 
                src="may1.webp" 
                alt="Luxury Fleet" 
                className="w-full h-96 object-cover rounded-lg shadow-lg"
              />
            </div>

            {/* Text Side */}
            <div>
              <h2 className="font-bold text-black mb-3 leading-tight">
                What we do
              </h2>
              <p className="mb-2 text-gray-900">
               Experience the ultimate in luxury and comfort with Majestic Voyague NYC  your trusted partner for premium limousine services in New York City. Whether it's airport transfers, corporate events, weddings, or a night out in town, we provide professional chauffeurs and high-end vehicles to make every journey special.
              </p>
              <p className="mb-3 text-gray-900">
              Our commitment to punctuality, cleanliness, and customer satisfaction makes us the preferred choice for thousands of clients across NYC. We believe in providing not just a ride – but an experience that reflects class, safety, and reliability.
              </p>
              <div className="flex gap-4">
                <a 
                  href="/booknow" 
                  className="bg-black border-2 border-white text-white px-8 py-3 font-semibold hover:bg-gray-900 transition-colors"
                >
                  Book Now
                </a>
                <a 
                  href="tel:+17182004140" 
                  className="bg-white text-black border-2 border-black px-8 py-3 font-semibold hover:bg-gray-100  transition-colors"
                >
                  CALL NOW
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full py-6 px-4 md:px-8 bg-white">
      <div className="max-w-4xl mx-auto">
        {/* WHO WE ARE heading */}
        <h2 className="font-bold text-black mb-8 text-center">
          OUR MISSION
        </h2>
        
        {/* Description paragraph */}
        <p className="text-gray-900 leading-relaxed mb-12 text-center">
          We are a team of highly trained chauffeurs, coordinators, and support staff committed to delivering 5-star ground transportation throughout NYC and surrounding areas. With years of experience in airport transportation, corporate travel, and luxury event services, Majestic Voygue NYC has become a trusted name for business travelers, tourists, locals, and special event organizers.
        </p>

        {/* Buttons container */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          {/* BOOK NOW link */}
          <a 
            href="/booknow" 
            className="bg-black text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-800 transition-colors w-full sm:w-auto min-w-[200px] text-center"
          >
            BOOK NOW
          </a>
          
          {/* CALL NOW link */}
          <a 
            href="tel:+17182004140" 
            className="bg-transparent border-2 border-black text-black px-8 py-4 rounded-lg font-semibold text-lg hover:bg-black hover:text-white transition-colors w-full sm:w-auto min-w-[200px] text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </section>

    <FAQ/>
    <Footer/>
    </>
  );
};

export default AboutUs;







